import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent, BaseEditFormModalComponent, FormlyService, IdDescription } from 'tms-lib';
import {
  ShipperInterfaceDetails,
  ShipperInterfaceDetailsService,
  ShippingPack,
  ShippingPackService,
} from 'tms-web-shared';

@Component({
  selector: 'app-shipper-interface-details-modal',
  templateUrl: './shipper-interface-details-modal.component.html',
  styleUrl: './shipper-interface-details-modal.component.scss',
})
export class ShipperInterfaceDetailsModalComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseEditFormModalComponent) form: BaseEditFormModalComponent;
  @Input() id: string;
  @Input() shippingInterfaceHeaderId: string;
  @Input() shipperSupplierId: string;

  fields: FormlyFieldConfig[];
  model: ShipperInterfaceDetails;

  private shippingPacks$: Observable<IdDescription[]>;

  constructor(
    public shipperInterfaceDetailsService: ShipperInterfaceDetailsService,
    public shippingPackService: ShippingPackService,
    private formlyService: FormlyService,
  ) {
    super();
  }

  ngOnInit() {
    this.shippingPacks$ = this.shippingPackService.search(undefined, this.shipperSupplierId);
    this.getFields();
  }

  private getFields() {
    this.fields = [
      this.formlyService.select('shippingPackId', $localize`Shipping Pack`, this.shippingPacks$, undefined, {
        required: true,
        change: (field: FormlyFieldConfig, event) => this.changeShippingPack(event?.value),
      }),
      this.formlyService.number('grossWeight', $localize`Weight`, undefined, { required: true }),
      this.formlyService.number('length', $localize`Length`, undefined, { required: true }),
      this.formlyService.number('width', $localize`Width`, undefined, { required: true }),
      this.formlyService.number('height', $localize`Height`, undefined, { required: true }),
    ];
  }

  private changeShippingPack(shippingPackId: string) {
    this.shippingPackService
      .edit(shippingPackId)
      .pipe(takeUntil(this.destroy$))
      .subscribe((model: ShippingPack) => this.form.updateModel(model, true));
  }
}
